export default {
  reportBuilder: 'Report Builder',
  subheadline: 'These settings define the global appearance of PDFs generated by Qmulus.',
};
